import WebflowInstall from "../../../../contents/docs/integrate/_snippets/install-webflow.mdx";
import * as React from 'react';
export default {
  WebflowInstall,
  React
};